function debug() {
    if(__yuki.env.isDev) {
        console.log.apply(null, arguments);
    }
}
function init() {
    debug('init theme');
}

init();